import { useEffect } from 'react';
import '../../../../shared/src/common/css/scheduler.css';
import SchedulerSteps from '@leadflow/shared/src/feature/scheduler/components/SchedulerStep/SchedulerSteps';
import ThemeProviderWrapper from '../../theme/ThemeContext';
import { SchedulerConfig } from '@leadflow/shared/src/Interface/scheduler/form';
import { FormProvider } from '@leadflow/shared/src/common/contexts/FormContext';
import { SharedStateProvider } from '@leadflow/shared/src/common/contexts/SharedStateContext';
import { useFormConfigContext } from '@leadflow/shared/src/common/contexts/FormConfigContext';
import { schedulerConfigJsonSequence } from '@leadflow/shared/src/common/components/Helper/Helper';

interface HTMLElementWithContent extends HTMLElement {
  textContent: string;
}

const App = () => {
  const { setFormConfig } = useFormConfigContext();
  useEffect(() => {
    const plgInlineFormConfig = document.getElementById(
      'data',
    ) as HTMLElementWithContent | null;
    if (plgInlineFormConfig?.textContent) {
      try {
        const plgJsonData = JSON.parse(
          plgInlineFormConfig.textContent,
        ) as SchedulerConfig;
        if (plgJsonData?.conceptid) {
          const stepOrder = plgJsonData.steps?.sort(
            (a, b) => Number(a.sequence) - Number(b.sequence),
          );
          const visibleSteps = stepOrder?.filter((step) => !step.hideStep);
          setFormConfig({ ...plgJsonData, steps: visibleSteps });
        }
      } catch (error) {
        console.error('Failed to parse JSON:', error);
      }
    } else {
      fetch('/scheduler-config.json')
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((plgData) => {
          if (plgData?.steps) {
            const formatData = schedulerConfigJsonSequence(plgData);
            setFormConfig(formatData);
          }
        })
        .catch((error) => console.error('Error fetching PLG config:', error));
    }
  }, []);

  return (
    <ThemeProviderWrapper>
      <FormProvider>
        <SharedStateProvider>
          <SchedulerSteps />
        </SharedStateProvider>
      </FormProvider>
    </ThemeProviderWrapper>
  );
};

export default App;
